export const SET_POPUP = 'SET_POPUP';
export const SET_CHILD_POPUP = 'SET_CHILD_POPUP';
